import 'twin.macro';
import React, { createContext, useContext } from 'react';
import Tbody from './Tbody';
import Thead from './Thead';
import Td from './Td';
import Tr from './Tr';
import Th from './Th';

interface Props {
  children: React.ReactNode;
  className?: string;
  id?: string;
  condensed?: boolean;
}

const TableContext = createContext({ condensed: false });

export const useTableContext = () => useContext(TableContext);

export default function Table(props: Props) {
  const { children, className, condensed = false, ...rest } = props;
  return (
    <TableContext.Provider value={{ condensed }}>
      <div className={className} tw="flex flex-col">
        <div tw="align-middle inline-block min-w-full">
          <div tw="overflow-hidden border-neutral-quiet sm:rounded-lg">
            <table tw="min-w-full divide-y divide-gray-200" {...rest}>
              {children}
            </table>
          </div>
        </div>
      </div>
    </TableContext.Provider>
  );
}

Table.Tbody = Tbody;
Table.Thead = Thead;
Table.Td = Td;
Table.Tr = Tr;
Table.Th = Th;
